import axios from "axios";

//IMPORT API ROUTE URL
import { REMOVE_ACCOUNT_ROUTE } from "./apiRoutes";

const removeAccount = (data) => {
  var postData = new FormData();

  postData.append("user_slug", data.user_slug);
  postData.append("resource_slug", data.resource_slug);

  return axios
    .post(REMOVE_ACCOUNT_ROUTE, postData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default removeAccount;
